import React, { useState, useEffect } from "react";
import NextTierSlider from "./nextTierSlider";
import TargetSpend from "./targetSpendChart";
import NIARebate from "./niaRebateChart";

const SpendGrowthRebate = (props: any) => {

    //Calculation for green pivot value from FE
    //   const [greenPivot, setGreenPivot] = useState(0);

    //     const points = [
    //         {0:props.rebateData.rebate['0.00%']},
    //         {80:props.rebateData.rebate['80.00%']},
    //         {85:props.rebateData.rebate['85.00%']},
    //         {90:props.rebateData.rebate['90.00%']},
    //         {95:props.rebateData.rebate['95.00%']},
    //         {100:props.rebateData.rebate['100.00%']},
    //         {102.5:props.rebateData.rebate['102.50%']},
    //         {105:props.rebateData.rebate['105.00%']},
    //         {107.5:props.rebateData.rebate['107.50%']},
    //         {110:props.rebateData.rebate['110.00%']},
    //         {112.5:props.rebateData.rebate['112.50%']},
    //         {115:props.rebateData.rebate['115.00%']},
    //         {117.5:props.rebateData.rebate['117.50%']},
    //         {120:props.rebateData.rebate['120.00%']},
    //       ];    

    //     useEffect(() => {
    //         let rightPivot = 0;
    //         let tempRightPivot = 0;
    //         const leftPivot = props.rebateData.yellowPivotValue*100;
    //         let leftPivotBreakPointValue = 0;
    //         points.map((item:any)=>{
    //             Object.keys(item).forEach((key:any)=>{
    //                 if(Number(key) <= leftPivot){
    //                     leftPivotBreakPointValue = item[key];
    //                 }
    //             })
    //         })
    //         points.map((item:any)=>{
    //            Object.keys(item).forEach((key:any)=>{
    //                 if( Number(key) > leftPivot){
    //                     if(tempRightPivot === 0){
    //                         tempRightPivot =  Number(key);
    //                         console.log('item[key]',item[key]);
    //                         console.log('Number(key)',Number(key));
    //                         console.log('leftPivot',leftPivot);
    //                         console.log('leftPivotBreakPoint',leftPivotBreakPointValue);
    //                     }  
    //                     if(rightPivot === 0){
    //                         if(item[key] > leftPivotBreakPointValue){
    //                             rightPivot = Number(key);
    //                             setGreenPivot(rightPivot);
    //                         }
    //                     }
    //                 }
    //            })
    //         })
    //         if(rightPivot === 0){
    //             setGreenPivot(tempRightPivot);
    //         }
    //       }, [props.rebateData.rebate])

    return (
      <div className="growth-rebate-container">
        <div className="nextTier-slider-section">
          <div className="slider-heading">Spend Growth % and Rebate Tiers</div>
          <NextTierSlider
            rebate={props.rebate}
            leftPivot={props.summary.forecastedGrowthPerc * 100}
            rightPivot={Number(props.summary.growthRequired.split("%")[0])}
          />
        </div>
        <div className="growth-rebate-label-wrappper">
          <div className="label-item">
            <div className="label-text">
              {(props.summary.forecastedGrowthPerc * 100).toFixed(2)}%
            </div>
            <div className="label-description">
              Forcasted growth % based <br /> on YTD spend
            </div>
          </div>
          <div className="label-item">
            <div className="label-text">
              {(
                props.summary.effectiveNIARebatePerc * 100 +
                props.rebate.rebate_base * 100
              ).toFixed(2)}
              %
            </div>
            <div className="label-description">
              Effective NIA rebate %<br /> based on YTD growth
            </div>
          </div>
          <div className="label-item">
            <div className="label-text green-label">
              {props.summary.forecastedGrowthPerc * 100 > 120
                ? "-"
                : props.summary.growthRequired}
            </div>
            <div className="label-description">
              Growth required for next
              <br /> rebate tier
            </div>
          </div>
          <div className="label-item">
            <div className="label-text green-label">
              {props.summary.forecastedGrowthPerc * 100 > 120
                ? "-"
                : (
                    props.summary.growthNIARebatePerc * 100 +
                    props.rebate.rebate_base * 100
                  ).toFixed(2) + "%"}
            </div>
            <div className="label-description">
              Effective NIA rebate % based
              <br /> on next tier growth
            </div>
          </div>
        </div>
        <div className="graph-section flex flex-row justify-between items-start h-[58%] gap-x-[3vw]">
          <div className="basis-[50%] flex flex-col justify-between h-full">
                    <span className="text-center text-[0.8vw] h-[5%]">Target Spend</span>
            <div className="h-[75%]">
              <TargetSpend data={props.targetSpendChartData} />
            </div>
            <div className="h-[20%] flex flex-wrap justify-start items-start gap-x-2">
              <div className="flex justify-start items-center">
                <div className="h-[2vh] w-[2vh] bg-[#62b5e5] mx-1"></div>
                            <span className="text-[1.8vh]">{new Date().getFullYear()} Actuals</span>
              </div>

              <div className="flex justify-start items-center">
                <div className="h-[2vh] w-[2vh] bg-[#92d050] mx-1"></div>
                <span className="text-[1.8vh]">Spend Needed for next tier</span>
              </div>

              <div className="flex justify-start items-center">
                <div className="h-[2vh] w-[2vh] bg-[#fcbe00] mx-1"></div>
                <span className="text-[1.8vh]">Forecasted Spend</span>
              </div>
            </div>
          </div>
          <div className="basis-[50%] flex flex-col justify-between h-full">
            <span className="text-center text-[0.8vw] h-[5%]">NIA Rebate</span>

            <div className="h-[75%]">
              <NIARebate data={props.niaRebateChartData} />
            </div>

            <div className="h-[20%] flex flex-wrap justify-start items-start gap-x-2">
              <div className="flex justify-start items-center">
                <div className="h-[2vh] w-[2vh] bg-[#0097a9] mx-1"></div>
                <span className="text-[1.8vh]">Forecasted Base</span>
              </div>

              <div className="flex justify-start items-center">
                <div className="h-[2vh] w-[2vh] bg-[#b08600] mx-1"></div>
                <span className="text-[1.8vh]">Forecasted Growth</span>
              </div>
              <div className="flex justify-start items-center">
                <div className="h-[2vh] w-[2vh] bg-[#0af680] mx-1"></div>
                <span className="text-[1.8vh]">Additional Base</span>
              </div>


              <div className="flex justify-start items-center">
                <div className="h-[2vh] w-[2vh] bg-[#e3e48d] mx-1"></div>
                <span className="text-[1.8vh]">Additional Growth</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default SpendGrowthRebate;
